export default "__VITE_ASSET__CZiQv8Bc__"